import React, { useState } from "react";
import axiosConfig from "../../axiosConfig";
import MaterialTable from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import MaterialUIPickers from "../Datepicker/Datepicker";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import { makeStyles } from "@material-ui/core/styles";
import exportCSV from "../../services/exportCSV";
import exportPDF from "../../services/exportPDF";
const useStyles = makeStyles(styles)

function UserLogging() {

  const [search, setSearch] = useState("");
  const classes = useStyles();

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 14);

  const [dateFrom, setDateFrom] = useState(currentDate.toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));
  const tableRef = React.createRef();


  const handleSearch = (e) => {
    setSearch(e.target.value);
  };


  const handleDateChangeFinal = (date) => {
    if (date) {
      setDateTo(date.toISOString().slice(0, 10))
      let previousDate = date.setDate(date.getDate() - 14)
      setDateFrom((new Date(previousDate)).toISOString().slice(0, 10))
    }
  }


  const datesSubmit = () => {
    tableRef.current && tableRef.current.onQueryChange()
  }



  return (
    <div>
      <Card>
        <CardHeader color="warning">
          <h1 className={classes.cardTitleWhite}>Log Κινήσεων Ενεργειών Χειριστών</h1>
        </CardHeader>
        <CardBody>
          <MaterialUIPickers
            initialDate={dateFrom}
            finalDate={dateTo}
            handleChange={handleSearch}
            handleDateChangeFinal={handleDateChangeFinal}
            datesSubmit={datesSubmit}
            search={true}
          />
        </CardBody>
      </Card>
      <MaterialTable
        tableRef={tableRef}
        icons={tableIcons}
        title=""
        columns={[
          {
            title: "Ενέργεια",
            field: "method",
          },
          { title: "Δεδομένα", field: "modelId" },
          { title: "Συνδεδεμένος Χειριστής", field: "userEmail" },
          { title: "Χειριστής Επιβεβαίωσης", field: "verifiedUserEmail" },
          { title: "Ημερομηνία", field: "dateCreated" },
        ]}
        data={query =>
          new Promise((resolve, reject) => {
            let url = '/UserManagement/GetPaginatedUserLogging?'
            url += 'dateFrom=' + dateFrom
            url += '&dateTo=' + dateTo
            url += '&limit=' + query.pageSize
            url += '&page=' + (query.page + 1)
            url += '&search=' + search
            axiosConfig(url)
              .then(result => {
                resolve({
                  data: result.data.items,
                  page: result.data.currentPage - 1,
                  totalCount: result.data.totalItems,
                })
              })
          })}
        localization={{
          body: {
            emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            filterRow: {
              filterTooltip: 'Φίλτρο',
              filterPlaceHolder: 'Αναζήτηση'
            }
          },
          toolbar: {
            showColumnsTitle: "Δείξτε κολώνες",
            addRemoveColumns: "Προσθέστε η αφαιρέστε κολώνες",
            addTooltip: "Προσθήκη",
            searchTooltip: "Αναζήτηση",
            searchPlaceholder: "Αναζήτηση",
            exportTitle: "Εξαγωγή",
            exportCSVName: "Εξαγωγή σε CSV",
            exportPDFName: "Εξαγωγή σε PDF",
          },
          pagination: {
            firstTooltip: "Πρώτη Σελίδα",
            lastTooltip: "Τελευταία Σελίδα",
            previousTooltip: "Προηγούμενη Σελίδα",
            nextTooltip: "Επόμενη Σελίδα",
            labelDisplayedRows: "{from}-{to} από {count}",
            labelRowsSelect: "Εγγραφές ανά Σελίδα",
          },
          grouping: {
            placeholder: "Σύρετε για να ομαδοποιήσετε",
            groupedBy: "Σύρετε για να ομαδοποιήσετε",
          },
          header: {
            actions: "Ενέργειες",
          },
        }}
        options={{
          searchFieldAlignment: "left",
          pageSize: 10,
          pageSizeOptions: [10, 15, 20],
          columnsButton: true,
          exportButton: true,
          exportPdf: (columns, data) => {
            exportPDF(columns, data);
          },
          exportCsv: (columns, data) => {
            exportCSV(columns, data);
          },
          grouping: false,
          sorting: true,
          filtering: false,
          exportAllData: true,
          search: false
        }}
      />
    </div>
  );
}


export default UserLogging;
